import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum PaymentPrescriptionTypeId {
  MANUAL = 'manual',
  AUTOMATIC = 'automatic',
  FULL_PAYMENT = 'fullpayment',
  MANUAL_FULL_PAYMENT = 'manual-fullpayment',
}

export class PaymentPrescriptionType extends Codebook<PaymentPrescriptionTypeId> {
  static readonly MANUAL = new PaymentPrescriptionType(PaymentPrescriptionTypeId.MANUAL, () =>
    $t('Manual'),
  )
  static readonly AUTOMATIC = new PaymentPrescriptionType(PaymentPrescriptionTypeId.AUTOMATIC, () =>
    $t('Automatic'),
  )
  static readonly FULL_PAYMENT = new PaymentPrescriptionType(
    PaymentPrescriptionTypeId.FULL_PAYMENT,
    () => $t('Automatic'),
  )
  static readonly MANUAL_FULL_PAYMENT = new PaymentPrescriptionType(
    PaymentPrescriptionTypeId.MANUAL_FULL_PAYMENT,
    () => $t('Manual'),
  )

  private constructor(
    public readonly id: PaymentPrescriptionTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
